<template>
  <div v-if="showNews" id="news_popup">
    <div class="">
      <div class="_8Mwnh" role="dialog" @click="showNews = false" />
      <div class="hUQsm" />
      <div class="T5hFd" />
      <div class="vtWDf">
        <div>
          <div style="height: auto; overflow: hidden auto;">
            <div style="flex-direction: column; padding-bottom: 0px; padding-top: 0px;">
              <div class="top_new">
                <div v-if="unreadCounter" class="news_counter">
                  {{ unreadCounter }}
                </div>
                <div class="top_new_text">
                  {{ unreadCounter ? 'News Unread' : 'You read all news' }}
                </div>
                <div class="top_news_close" @click="showNews = false">
                  X
                </div>
              </div>

              <div
                v-for="(neww, index) in news"
                :key="neww.id"
                :class="{ 'unread': !neww.hasSeen }"
                class="PUHRj  H_sJK"
                role="button"
                tabindex="0"
              >
                <div
                  class="cek9Q"
                >
                  <div v-if="neww.targetId || neww.initiatorId" class="H59PT" @click="showUser(neww)">
                    <div class="RR-M- h5uC0" role="button" tabindex="0">
                      <canvas
                        class="CfWVH"
                        height="84"
                        width="84"
                        style="position: absolute; top: -4px; left: -4px; width: 42px; height: 42px;"
                      />
                      <span class="_2dbep " role="link" tabindex="0">
                        <img
                          v-lazy-load :data-src="getUser(neww.initiatorId || neww.targetId).profilePhotoThumbnail || getUser(neww.initiatorId || neww.targetId).image"
                          style="width: 34px; height: 34px;"
                          class="_6q-tv"
                        ></span>
                    </div>
                  </div>
                </div>
                <div class="YFq-A" @click="onNewsClick(neww)">
                  <div class="HkZvO">
                    <a :title="getUser(neww.initiatorId).name" class="FPmhX notranslate  yrJyr">{{
                      getUser(neww.initiatorId).name }}</a>
                  </div>
                  {{ types[typesKeys[neww.type]] }}
                  <time class="HsXaJ Nzb55" datetime="2019-11-11T19:53:29.901Z" title="Nov 11, 2019">
                    {{ getDiff(neww.createdAt) }}
                  </time>
                </div>
                <div class="iTMfC">
                  <a class="kIKUG H-dnq">
                    <div class="eLAPa GzVn2">
                      <div
                        v-if="neww.orderId"
                        class="KL4Bh"
                        @click="onItemClick(getItem(getOrder(neww.orderId).itemId), $event)"
                      >
                        <img
                          v-lazy-load :data-src="getItem(getOrder(neww.orderId).itemId).image"
                          class="FFVAD"
                          decoding="auto"
                          sizes="40px"
                          style="object-fit: cover;"
                        ></div>
                      <div
                        v-if="!neww.orderId && neww.itemId"
                        class="KL4Bh"
                        @click="onItemClick(neww, getItem(neww.itemId), $event)"
                      >
                        <img
                          v-lazy-load :data-src="getItem(neww.itemId).itemPhotoThumbnail || getItem(neww.itemId).image"
                          class="FFVAD"
                          decoding="auto"
                          sizes="40px"
                          style="object-fit: cover;"
                        ></div>
                      <div v-if="neww.type === 2 && indexToHide !== index" class="follow_button" @click="onFollowClick(getUser(neww.initiatorId), index)">{{ getUser(neww.initiatorId).extra.isFollowed === 'false' ? 'Follow' : 'Following' }}</div>
                      <div class="_9AhH0" />
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '~/mixins/utils'

export default {
  name: 'NewsComponent',
  mixins: [utils],
  data () {
    return {
      indexToHide: -1,
      news: [],
      showNews: false,
      types: {
        NONE: 'Welcome to GOTit\nHere you will find news from people\nand stores that you follow',
        LIKE: 'Liked your items',
        FOLLOW: 'Started following you',
        COMMENT: 'Commented on your items',
        OFFER: 'Made you an offer',
        WANT_IT: 'Wants your items',
        GOT_IT: 'Got your items',
        GIFT_IT: 'Gifted you with an items',
        QUANTITY: 'Your GIT for the items reached its minimum quantity',
        COMMIT_TO_BUY: 'Has committed to buy your items',
        STORE_GIT: 'Openned GETit TOGETHER for your items',
        FACEBOOK: 'Your Facebook friend has joined GOTit',
        GROUP_MESSAGE: 'You have a new group message',
        SALE_IT: 'An items you want is on sale',
        ITEM_KING: 'You are this items king',
        OFFER_COMMENT: 'Commented on your offer',
        USERNAME_MENTIONED_IN_COMMENT: 'Mentioned you in a comment',
        SHARED_ITEM_AT_STORE_LOCATION: 'Shared an items with your location',
        GIFT_IT_REQUEST: 'Sent you a GIFTit Request',
        GIFT_IT_CONFIRMATION: 'Confirmed your GIFTit request',
        GIFT_IT_COMMENT: 'Commented on a GIFTit Request',
        GIFT_IT_REJECT: 'Rejected your GIFTit request',
        ORDER_PAID: 'GOTit with PayPal',
        ORDER_ACCEPTED: 'Confirmed your order',
        ORDER_REJECTED: 'Rejected your order',
        ORDER_COMMENT: 'Commented on your order',
        ORDER_DELIVERED: 'Shipped your order',
        ORDER_CONFIRMED: 'Confirmed delivery',
        LEFT_FEEDBACK: 'Left you a feedback',
        NEW_ORDER_CREATED: 'View your new order',
        PAYPAL_PAYMENT_FAILED: 'Payment failed',
        OPEN_EXPLORE: 'Explore GOTit',
        OPEN_EXPLORE_DEALS: 'Check out our special deals!',
        OPEN_ITEM: 'Item of the day!',
        OPEN_USER: 'Store of the day!',
        OPEN_CATEGORY: 'Category of the day!',
        PRIVATE_MESSAGE: 'Sent you a private message',
        AUTO_OFFER: 'Your price offer was accepted',
        FEEDBACK_REMINDER: 'Leave feedback reminder',
        REQUEST_RETURN: 'sent you a return request',
        RETURN_ACCEPTED: 'accepted your return request',
        RETURN_REJECTED: 'rejected your return request',
        ITEM_RETURNED: 'Item returned to the stores',
        REFUNDED: 'Order refunded',
        SENT_CREDIT: 'Sent you CREDit',
        CREDIT_CARD_PAYED: 'GOTit with credit card',
        CREDIT_EXPIRING: 'Your credit is expiring in %d days. Enjoy it while it lasts',
        ITEM_RESTOCKED: 'An items you want is restocked!',
        CART_CHECKOUT: 'New orders were created',
        SUBSCRIPTION_CREATED: 'Your subscription order was created',
        SUBSCRIPTION_ORDER_CREATED: 'You have a new subscription package order',
        SUBSCRIPTION_CANCELED: 'Your subscription has been cancelled',
        SUBSCRIPTION_FAILED: 'Your subscription payment failed',
        NEWS_SOCIAL_CREDIT_JOINED: 'Just joined GOTit, You got $@ credit!',
        NEWS_SOCIAL_CREDIT_PURCHASED: 'Got his 1st items, You got $@ credit!',
        NEWS_DISPUTE_MESSAGE: 'Commented on your order'
      },
      typesKeys: [],
      unreadCounter: 0
    }
  },
  mounted () {
    this.unreadCounter = this.$store.state.api.globals.newsUnread
    this.typesKeys = Object.keys(this.types)
    if (this.showNews) {
      this.$store.dispatch('api/selectNews', {
        filter: 'USER_ALL'
      }).then((news) => {
        this.news = news
        this.$store.state.api.globals.newsUnread = 0
        this.$root.$emit('on_globals_ready')
      })
    }
    this.$root.$on('toggle_show_news', () => {
      this.showNews = !this.showNews
      if (this.showNews && this.news.length === 0) {
        this.$store.dispatch('api/selectNews', {
          filter: 'USER_ALL'
        }).then((news) => {
          this.news = news
          this.$store.state.api.globals.newsUnread = 0
          this.$root.$emit('on_globals_ready')
        })
      }
    })
  },
  methods: {
    onNewsClick (newEntity) {
      switch (this.typesKeys[newEntity.type]) {
        case 'CART_CHECKOUT':
          this.$router.push({
            path: '/orders'
          })
          break
        case 'PRIVATE_MESSAGE':
          this.$router.push({
            path: '/comments'
          })
          break
        case 'SALE_IT':
          this.addItemDetailsToEventsLayer('select_item', newEntity.itemId)
          this.$router.push({
            path: '/items/' + this.encrypt(newEntity.itemId)
          })
          break
        case 'NEWS_SOCIAL_CREDIT_PURCHASED':
        case 'NEWS_SOCIAL_CREDIT_JOINED':
        case 'SENT_CREDIT':
          this.$router.push({
            path: '/offers'
          })
          break
        case 'WANT_IT':
          if (newEntity.initiatorId) {
            this.$router.push({
              path: '/users/' + this.encrypt(newEntity.initiatorId)
            })
          } else if (newEntity.itemId) {
            this.addItemDetailsToEventsLayer('select_item', newEntity.itemId)
            this.$router.push({
              path: '/items/' + this.encrypt(newEntity.itemId)
            })
          }
          break
        case 'ORDER_ACCEPTED':
        case 'ORDER_REJECTED':
        case 'ORDER_COMMENT':
        case 'ORDER_DELIVERED':
        case 'RETURN_ACCEPTED':
        case 'ORDER_CONFIRMED':
          this.$router.push({
            path: '/orders/' + this.encrypt(newEntity.orderId)
          })
          break
        default:
          console.log(this.typesKeys[newEntity.type])
          break
      }
      this.setHasSeend(newEntity)
    },
    setHasSeend (newEntity) {
      newEntity.hasSeen = true
      // eslint-disable-next-line no-unused-vars
      this.$store.dispatch('api/updateNew', newEntity).then().catch()
    },
    showUser (neww) {
      const user = this.getUser(neww.initiatorId)
      if (user.store) {
        this.$router.push({
          path: '/stores/' + this.encrypt(user.id)
        })
      } else {
        this.$router.push({
          path: '/users/' + this.encrypt(user.id)
        })
      }
      this.setHasSeend(neww)
    },
    getUser (userId) {
      return this.$store.state.api.buckets.users[userId]
    },
    getOrder (orderId) {
      return this.$store.state.api.buckets.orders[orderId]
    },
    async onFollowClick (user, index) {
      let isFollowed = 'true'
      if (user.extra.isFollowed === 'true') {
        isFollowed = 'false'
        user.extra.isFollowed = 'true'
      } else {
        user.extra.isFollowed = 'false'
      }
      const params = {
        id: user.id,
        typeParam: isFollowed,
        type: 'FOLLOW'
      }
      user = await this.$store.dispatch('api/userExecute', params)
      this.indexToHide = index
      this.$emit('onFollowChanged', user)
      this.$store.dispatch('api/followEvent', {
        isFollowed
      }).then().catch()
      setTimeout(() => {
        this.indexToHide = -1
      }, 10)
    },
    getItem (userId) {
      return this.$store.state.api.buckets.items[userId]
    },
    onItemClick (neww, item, $event) {
      this.addItemDetailsToEventsLayer('select_item', item.id)
      this.$router.push({
        path: '/items/' + this.encrypt(item.id)
      })
      this.setHasSeend(neww)
      $event.stopPropagation()
    },
    getDiff (date) {
      const date1 = new Date(date)
      const currentDate = new Date()
      const diffDays = parseInt((currentDate - date1) / (1000 * 60 * 60 * 24), 10)
      if (diffDays < 7) {
        return diffDays + 'd'
      } else {
        return parseInt(diffDays / 7) + 'w'
      }
    }
  }
}
</script>

<style scoped>
  #news_popup {
    right: 5.1em;
    top: 1em;
  }
  ._8Mwnh {
    opacity: .5;
    bottom: 0;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 10;
  }

  .jh4T5 .hUQsm {
    top: 4px;
  }

  .hUQsm {
    background: #fff;
    border: 1px solid #e6e6e6;
    -webkit-box-shadow: 0 0 5px 1px rgba(0, 0, 0, .0975);
    box-shadow: 0 0 5px 1px rgba(0, 0, 0, .0975);
    height: 14px;
    left: -48px;
    top: 8px;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
    width: 14px;
    z-index: 1;
  }

  .T5hFd, .hUQsm {
    content: ' ';
    position: absolute;
  }

  .jh4T5 .T5hFd {
    top: 2px;
  }

  .T5hFd {
    border-color: transparent transparent #fff;
    border-style: solid;
    border-width: 0 10px 10px;
    height: 0;
    top: 6px;
    left: -51px;
    width: 0;
    z-index: 12;
  }

  .T5hFd, .hUQsm {
    content: ' ';
    position: absolute;
  }

  .jh4T5 .vtWDf {
    top: 11px;
  }

  .vtWDf {
    background: #fff;
    border-radius: 3px;
    border: solid 1px #e6e6e6;
    -webkit-box-shadow: 0 0 15px 10px rgba(0, 0, 0, .0975);
    box-shadow: 0 0 15px 10px rgba(0, 0, 0, .0975);
    display: block;
    margin-left: -423px;
    max-height: 362px;
    min-height: 100px;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 0;
    position: absolute;
    top: 15px;
    white-space: normal;
    width: 500px;
    z-index: 11;
  }

  .H_sJK {
    cursor: pointer;
  }

  .PUHRj {
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    min-height: 40px;
    padding: 12px 16px 13px;
    position: relative;
  }

  .YFq-A {
    color: #262626;
    display: block;
    -webkit-box-flex: 1;
    -webkit-flex: 1 0 0%;
    -ms-flex: 1 0 0%;
    flex: 1 0 0%;
    line-height: 1.3;
    margin: 0 12px;
    min-width: 0;
    word-wrap: break-word;
    align-items: start !important;
    justify-content: start !important;
    text-align: left;
  }

  .cek9Q, .iTMfC {
    display: block;
    -webkit-box-flex: 0;
    -webkit-flex: 0 0 auto;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
  }

  .yrJyr, .yrJyr:visited {
    color: #262626;
    font-weight: 600;
  }

  a, a:visited {
    color: #003569;
    color: rgba(var(--fe0, 0, 53, 105), 1);
    text-decoration: none;
  }

  .FPmhX {
    font-weight: 600;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-left: 5px;
    margin-left: -5px;
  }

  @media (min-width: 736px) {
    .Nzb55 {
      font-size: 15px;
      line-height: 18px;
    }
  }

  @media (min-width: 736px) {
    .Nzb55 {
      font-size: 15px;
      line-height: 18px;
    }

    .HsXaJ {
      color: #999;
      margin-left: 5px;
    }
  }

  @media (min-width: 736px) {
    .Nzb55 {
      font-size: 15px;
      line-height: 18px;
    }
  }

  .HkZvO {
    -webkit-box-flex: 1;
    -webkit-flex: 1 1 auto;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
  }

  div {
    -webkit-box-align: stretch;
    -webkit-align-items: stretch;
    -ms-flex-align: stretch;
    align-items: stretch;
    border: 0 solid #000;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-flex-shrink: 0;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    margin: 0;
    padding: 0;
    position: relative;
  }

  .PUHRj::after {
    border-bottom: 1px solid #efefef;
    bottom: 0;
    content: '';
    height: 0;
    left: 58px;
    position: absolute;
    right: 12px;
  }

  .unread {
    background-color: rgba(240, 218, 220, 0.35);
  }

  .cek9Q, .iTMfC {
    display: block;
    -webkit-box-flex: 0;
    -webkit-flex: 0 0 auto;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
  }

  .YFq-A {
    color: #262626;
    display: block;
    -webkit-box-flex: 1;
    -webkit-flex: 1 0 0%;
    -ms-flex: 1 0 0%;
    flex: 1 0 0%;
    line-height: 1.3;
    margin: 0 12px;
    min-width: 0;
    word-wrap: break-word;
  }

  .top_new {
    display: flex;
    flex-direction: row;
    padding: 1em;
  }

  .news_counter {
    background-color: #ed4956;
    border-radius: 17px;
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    height: 34px;
    line-height: 34px;
    text-align: center;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    width: 34px;
  }
  .top_new_text {
    flex-grow: 1;
    text-align: left;
    line-height: 100%;
    align-self: center;
    margin-left: 1em;
  }

  .top_news_close {
    align-self: center;
    color: #7F828B;
    cursor: pointer;
  }

  .FFVAD {
    width: 40px;
    height: 40px;
  }
</style>
